import { Back, Elastic, Sine, TimelineLite, TimelineMax, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";

export class SplashLoadingText extends PIXI.Container {
    private readonly _letters: PIXI.extras.BitmapText[];
    private _loop: TimelineMax | undefined;

    constructor() {
        super();
        const text: string = Application.instance.copy.getCopy("loading");
        this._letters = new Array<PIXI.extras.BitmapText>(text.length);
        let totalWidth: number = 0;
        let halfWidth: number = 0;
        let accumWidth: number = 0;

        // Create all letters
        for (let i = 0; i < this._letters.length; ++i) {
            this._letters[i] = new PIXI.extras.BitmapText(text.charAt(i), {
                font: Constants.FONT_LUNA,
                align: "left", // TODO:SH: FontUtils that contains these alignments as consts
                tint: (new HLF.Colour(0, 0, 0)).toHex(),
            });
            this._letters[i].anchor = new PIXI.Point(0, 0.5);
            totalWidth += this._letters[i].textWidth;
            if (this._letters[i].text === ".") {
                totalWidth += this._letters[i].textWidth;
            }
        }
        // Position letters
        halfWidth = totalWidth * 0.5;
        for (let i = 0; i < this._letters.length; ++i) {
        // for (let i = 0; i < this._letters.length; ++i) {
            this._letters[i].position.set(-halfWidth + accumWidth, 0);
            accumWidth += this._letters[i].textWidth;
            if (this._letters[i].text === ".") {
                this._letters[i].position.x += this._letters[i].textWidth;
                accumWidth += this._letters[i].textWidth;
            }
            this.addChild(this._letters[i]);
        }
        this.visible = false;
    }

    public animateIn(pOnComplete: () => void): void {
        for (let i = 0; i < this._letters.length; ++i) {
            this._letters[i].position.y = 40;
            this._letters[i].alpha = 0;
        }
        this.visible = true;

        const timeline: TimelineLite = new TimelineLite();

        const dur: number = 0.5;
        const delay: number = 0.05;

        for (let i = 0; i < this._letters.length; ++i) {
            timeline.to(this._letters[i], dur, {
                y: 0,
                ease: Back.easeOut,
            }, i * delay);
            timeline.to(this._letters[i], dur, {
                alpha: 1,
                ease: Sine.easeOut,
            }, i * delay);
        }
        timeline.add(this.animateLoop.bind(this));
        timeline.add(pOnComplete);
    }

    public animateOut(): void {
        if (this._loop !== undefined) {
            this._loop.kill();
        }

        const timeline: TimelineLite = new TimelineLite();

        const dur: number = 0.3;
        const delay: number = 0.05;

        for (let i = 0; i < this._letters.length; ++i) {
            timeline.to(this._letters[i], dur, {
                y: 10,
                ease: Back.easeIn,
            }, i * delay);
            timeline.to(this._letters[i], dur, {
                alpha: 0,
                ease: Sine.easeIn,
            }, i * delay);
        }
        timeline.call(() => this.visible = false);
    }

    private animateLoop(): void {
        const upDur: number = 0.3;
        const downDur: number = 1.75;
        const interval: number = 0.075;
        const displacement: number = -15;

        this._loop = new TimelineMax({
            repeat: -1,
        });
        for (let i = 0; i < this._letters.length; ++i) {
            this._loop.add(TweenMax.to(this._letters[i].position, upDur, {
                y: displacement,
                ease: Sine.easeInOut,
            }), i * interval);
            this._loop.add(TweenMax.to(this._letters[i].position, downDur, {
                y: 0,
                ease: Elastic.easeOut,
            }), (i * interval) + upDur);
        }
    }
}
